const Tutorial = () => {
  return (
    <>
      <div className="mb-8 px-4 py-6 rounded-xl bg-gradient-to-r from-[#f0f0f0] to-[#f8f8f8]">
        <video
          className="rounded-lg"
          src={`${process.env.PUBLIC_URL}/videos/tutorial/face/video.mp4`}
          poster={`${process.env.PUBLIC_URL}/videos/tutorial/face/thumbnail.png`}
          preload
          controls
          controlsList="nodownload nofullscreen noplaybackrate noremoteplayback"
          playsInline
          disablePictureInPicture
          disableRemotePlayback
          onEnded={(e) => {
            e.target.pause();
            e.target.currentTime = 0;
            e.target.load();
          }}
        />
        <h3 className="mt-4 text-sm text-primary font-medium">
          How to do a <span className="text-secondary">face</span> scan?
        </h3>
        <p className="mt-1 text-xs text-primary/70">Learn how a face scan works. It's as easy as taking a selfie.</p>
      </div>
      <div className="mb-8 px-4 py-6 rounded-xl bg-gradient-to-r from-[#f0f0f0] to-[#f8f8f8]">
        <video
          className="rounded-lg"
          src={`${process.env.PUBLIC_URL}/videos/tutorial/finger/video.mp4`}
          poster={`${process.env.PUBLIC_URL}/videos/tutorial/finger/thumbnail.png`}
          preload
          controls
          controlsList="nodownload nofullscreen noplaybackrate noremoteplayback"
          playsInline
          disablePictureInPicture
          disableRemotePlayback
          onEnded={(e) => {
            e.target.pause();
            e.target.currentTime = 0;
            e.target.load();
          }}
        />
        <h3 className="mt-4 text-sm text-primary font-medium">
          How to do a <span className="text-secondary">finger</span> scan?
        </h3>
        <p className="mt-1 text-xs text-primary/70">
          Learn how to place your finger on the rear camera and the flashlight.
        </p>
      </div>
    </>
  );
};

export default Tutorial;
